import React from "react"
import PropTypes from "prop-types"
import {Table, Badge} from "antd"
import {NavLink} from "react-router-dom"
const PersonAffiliations = ({links, loading}) => {
    const columns = [
        {
            title: 'Primary', dataIndex: 'primary', key: 'primary',
            render: primary => <Badge status={primary ? 'success' : 'default'}/>
        },
        {title: 'aPureBase ID', dataIndex: 'siteId',render: (text, record) => <NavLink to={`/site/${record.id}`}>{text}</NavLink>},
        {title: 'Site Name', dataIndex: 'siteName', key: 'siteName'},
        {title: 'Department', dataIndex: 'department', key: 'department'},
        {title: 'Street', dataIndex: 'street', key: 'street'},
        {title: 'City', dataIndex: 'city', key: 'city'}

    ];
    console.log(links);
    return <Table columns={columns} dataSource={links} size="small" bordered loading={loading}/>
};

PersonAffiliations.propTypes = {
    links: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired
};


export default PersonAffiliations


// WEBPACK FOOTER //
// ./src/js/browse/person/PersonAffiliations.js